// React
import React from "react";

// Scrollbars
import { ScrollBars } from "../ScrollBars";

// Material
import { withStyles, makeStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import InputBase from "@material-ui/core/InputBase";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CircularProgress from "@material-ui/core/CircularProgress";

import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import RoomIcon from "@material-ui/icons/Room";
import WebIcon from "@material-ui/icons/Web";
import SvgIcon from "@material-ui/core/SvgIcon";

import BlenderIconW1x from "../../imgs/BlenderIconW@1x.png";
import BlenderIconW2x from "../../imgs/BlenderIconW@2x.png";

import UnityIconW1x from "../../imgs/UnityIconW@1x.png";
import UnityIconW2x from "../../imgs/UnityIconW@2x.png";

import BrowserIcon1X from "../../imgs/BrowserIcon@1x.png";
import BrowserIcon2X from "../../imgs/BrowserIcon@2x.png";

// Massless
import { useSpace } from "../../context/SpaceContext";
import * as Utility from "../../massless/Utility";
import { LightInspector } from "./LightInspector";
import { CameraInspector } from "./CameraInspector";

import { Scrollbars } from "react-custom-scrollbars";

const useStyles = makeStyles((theme) => ({
  panelRoot: {
    opacity: "inherit",
    backgroundColor: "#ffffff",
    // borderRadius: theme.spacing(2),

    marginBottom: theme.spacing(1),
    // overflowX: "auto",
    [theme.breakpoints.down("md")]: {
      height: "45%",
      marginTop: "4px",
      overflow: "visible",
      padding: "20px",
    },
    [theme.breakpoints.up("md")]: {
      height: "45%",
      marginTop: "0",
      overflow: "hidden",
      padding: "20px 20px 0 20px",
    },
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.875rem",
  },
  platformSelect: { height: "30px", marginLeft: "10px" },
  autoConvertSwitch: { marginLeft: "auto" },
  inspectSectionTitle: { fontSize: "0.75rem" },
  textField: {
    width: "100%",
    fontWeight: "400",
    // backgroundColor: "#13142F",
    border: "1px solid #D9DFF2",
    fontSize: "0.7rem",
    borderRadius: "2px",
    padding: "0 2px",
    height: "20px",
    color: "#FFFFFF",
  },
  vectorLabel: {
    fontSize: "0.7rem",
    marginRight: "8px",
  },
  vectorField: {
    display: "flex",
    width: "33%",
    marginLeft: "6px",
  },
  vectorFieldLabel: {
    color: "#676784",
    fontSize: "12px",
    marginRight: "3px",
    textTransform: "uppercase",
    alignSelf: "center",
  },
  vectorArray: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
  },
}));

//#region SVG Icons
function BlenderIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12.4683 13.1208C12.5093 12.3817 12.8687 11.7305 13.4108 11.269C13.9425 10.8157 14.658 10.5385 15.4388 10.5385C16.2188 10.5385 16.9343 10.8157 17.4664 11.269C18.0081 11.7305 18.3672 12.3817 18.409 13.1201C18.45 13.8795 18.1472 14.5851 17.6155 15.1079C17.0734 15.6397 16.3023 15.9736 15.4392 15.9736C14.5756 15.9736 13.8031 15.6397 13.2617 15.1079C12.7293 14.5851 12.4269 13.8795 12.4683 13.1208ZM7.73823 14.6144C7.74345 14.9036 7.8348 15.4658 7.97239 15.9045C8.26098 16.8336 8.75091 17.6928 9.43211 18.4503C10.1312 19.2289 10.9925 19.8542 11.9869 20.2981C13.0324 20.7645 14.1648 21.0019 15.3415 21C16.516 20.9985 17.6487 20.7563 18.6942 20.2864C19.6886 19.838 20.5492 19.2101 21.2471 18.4312C21.928 17.6707 22.4172 16.8095 22.7065 15.8804C22.8519 15.411 22.944 14.9348 22.9809 14.4567C23.0171 13.9857 23.0018 13.514 22.9354 13.0427C22.8057 12.1241 22.4902 11.2626 22.0044 10.4769C21.56 9.75511 20.9873 9.12305 20.3064 8.59127L20.3079 8.59014L13.4355 3.27491C13.4291 3.2704 13.4243 3.26514 13.4176 3.26101C12.9664 2.91212 12.2084 2.91325 11.7125 3.26289C11.211 3.61629 11.1536 4.20065 11.5999 4.56907L11.598 4.57095L14.4645 6.91854L5.72817 6.92793C5.72407 6.92793 5.7196 6.92793 5.71661 6.92793C4.99439 6.92868 4.30014 7.40602 4.16293 8.00916C4.02161 8.62357 4.51229 9.13319 5.26285 9.13582L5.26173 9.13845L9.68976 9.12981L1.78784 15.2393C1.77777 15.2469 1.76696 15.2547 1.75764 15.2619C1.0123 15.8369 0.771065 16.7926 1.24086 17.3977C1.71737 18.0128 2.73042 18.0139 3.48358 17.401L7.79603 13.846C7.79603 13.8464 7.73339 14.3264 7.73823 14.6144ZM18.8199 16.2214C17.9313 17.1333 16.6871 17.6504 15.3411 17.653C13.9932 17.6553 12.749 17.143 11.8605 16.2327C11.4261 15.7892 11.1073 15.2788 10.9105 14.735C10.7177 14.2006 10.6428 13.6335 10.6924 13.0615C10.7393 12.5023 10.9045 11.9686 11.1685 11.486C11.4276 11.0117 11.7848 10.5828 12.2255 10.2201C13.0894 9.511 14.189 9.12718 15.3393 9.12568C16.4906 9.12418 17.5894 9.50424 18.4541 10.211C18.8941 10.5723 19.2509 10.9993 19.51 11.4729C19.7751 11.9551 19.9392 12.4869 19.988 13.0476C20.0369 13.6192 19.9619 14.1852 19.7691 14.72C19.5719 15.2653 19.2542 15.776 18.8199 16.2214Z" />
    </SvgIcon>
  );
}

function UnityIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18.2132 17.6438L14.7144 11.7527L18.2132 5.85977L19.9033 11.7527L18.2132 17.6438ZM10.4146 17.0781L6.01423 12.7082H13.0099L16.5069 18.6011L10.4146 17.0781ZM10.4146 6.42374L16.5087 4.90066L13.0099 10.7936H6.01423L10.4146 6.42374ZM19.3681 2L11.4025 4.07626L10.2242 6.09865L7.83186 6.08069L2 11.7527L7.83006 17.4229L10.2206 17.4049L11.4025 19.4273L19.3663 21.5036L21.5 13.7607L20.2876 11.7545L21.5 9.74827L19.3681 2Z" />
    </SvgIcon>
  );
}
//#endregion
function InspectorTextField(props) {
  const classes = useStyles();
  return (
    <Box className={classes.vectorField}>
      <Typography className={classes.vectorFieldLabel}>
        {props.label}:
      </Typography>
      <InputBase
        className={classes.textField}
        inputProps={{ style: { textAlign: "right" } }} // the change is here
        id={props.id}
        label={props.label}
        value={props.value}
        // inputProps={{ style: { width: props.width, fontSize: "14px" } }}
        InputProps={{
          readOnly: true,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        size="small"
        {...props}
      />
    </Box>
  );
}

function InspectorVectorField(props) {
  const classes = useStyles();
  const textFieldWidth = "100%";
  return (
    <Box className={classes.vectorArray}>
      <Tooltip title={props.title} classes={{ tooltip: classes.toolTip }}>
        <Box className={classes.vectorLabel}>{props.label}</Box>
      </Tooltip>
      {Object.entries(props.vector).map((entry) => {
        const [key, value] = entry;
        return (
          <InspectorTextField
            disabled
            color="primary"
            id={"outlined-number-" + key}
            label={key.replace("_", "")}
            value={Number(value).toFixed(2)}
            width={textFieldWidth}
          />
        );
      })}
    </Box>
  );
}

function TransformInspector(props) {
  const classes = useStyles();

  const { getTransform } = useSpace();
  const [transform, setTransform] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    getTransform({
      nodeRef: props.spaceNode.ref,
      transformRef: props.spaceNode.transformRef,
      platform: props.platform,
      ...props.spaceInfo,
    }).then((transform) => {
      setTransform(Utility.convertTransform(props.spaceNode, transform));
      setLoading(false);
    });
  }, [props.spaceNode, props.platform]);

  return (
    <>
      {" "}
      <Typography className={classes.inspectSectionTitle}>
        Transform
        {loading && (
          <CircularProgress size={10} style={{ marginLeft: "16px" }} />
        )}
      </Typography>
      <Box>
        {transform != null && (
          <>
            <InspectorVectorField
              label="T"
              title="Translation"
              vector={transform.position}
            />
            <InspectorVectorField
              label="R"
              title="Rotation"
              vector={transform.rotation}
            />
            <InspectorVectorField
              label="S"
              title="Scale"
              vector={transform.scale}
            />
          </>
        )}
      </Box>{" "}
    </>
  );
}

function InspectorPanels(props) {
  const classes = useStyles();

  const [autoConvertSwitch, setAutoConvertSwitch] = React.useState(true);
  const [platform, setPlatform] = React.useState("web");

  const render = () => {
    return (
      <>
        <Box className={classes.sectionTitle}>
          {props.spaceNode.name == null ? "<no name>" : props.spaceNode.name}
          <Tooltip classes={{ tooltip: classes.toolTip }} title="Auto Convert">
            <Switch
              className={classes.autoConvertSwitch}
              size="small"
              checked={autoConvertSwitch}
              onChange={(e) => {
                setAutoConvertSwitch(e.target.checked);
              }}
              color="primary"
              name="checkedB"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </Tooltip>
          <Select
            className={classes.platformSelect}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={(e) => {
              setPlatform(e.target.value);
            }}
            value={platform}
            color="primary"
          >
            <MenuItem value="web">
              <WebIcon fontSize="small" />
            </MenuItem>
            <MenuItem value="unity">
              <UnityIcon fontSize="small" />
            </MenuItem>
            <MenuItem value="blender">
              <BlenderIcon fontSize="small" />
            </MenuItem>
          </Select>
          <Divider />
        </Box>
        {/*** Inspectors *************************************************/}
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
        <TransformInspector
          spaceNode={props.spaceNode}
          spaceInfo={props.spaceInfo}
          platform={platform}
        />
        {props.spaceNode && props.spaceNode.type == "light" && (
          <>
            <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
            <LightInspector platform={platform} spaceNode={props.spaceNode} />
          </>
        )}
        {props.spaceNode && props.spaceNode.type == "camera" && (
          <>
            <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
            <CameraInspector platform={platform} spaceNode={props.spaceNode} />
          </>
        )}
      </>
    );
  };
  return render();
}

export function Inspector(props) {
  const classes = useStyles();

  const [autoConvertSwitch, setAutoConvertSwitch] = React.useState(true);
  const [platform, setPlatform] = React.useState("web");

  // React.useEffect(() => {
  //   console.log("spaceNode changed");
  //   console.log(props.spaceNode)
  // }, [props.spaceNode]);

  const render = () => {
    return (
      <Box className={classes.panelRoot}>
        {props.spaceNode != null && (
          <>
            <Hidden smDown>
              <ScrollBars style={{ height: "100%" }} autoHide>
                <InspectorPanels
                  spaceNode={props.spaceNode}
                  spaceName={props.spaceName}
                  spaceInfo={props.spaceInfo}
                />
              </ScrollBars>
            </Hidden>
            <Hidden mdUp>
              <InspectorPanels
                spaceNode={props.spaceNode}
                spaceName={props.spaceName}
                spaceInfo={props.spaceInfo}
              />
            </Hidden>
          </>
        )}
      </Box>
    );
  };
  return render();
}
